import {
  AudienceSurveyResponseTargetingAttributeFragment,
  GeneralSurveyFragment,
  LocationFragment,
  LocationGroupFragment,
} from '@occc/graphql';

import { isNotUndefined } from './utils';

import { SurveyAttribute } from '../../routes/Audience/types';

export const prepareSurveyAttributes = (
  surveyItems: AudienceSurveyResponseTargetingAttributeFragment[],
  surveys: GeneralSurveyFragment[],
  locations?: LocationFragment[],
  locationGroups?: LocationGroupFragment[],
): SurveyAttribute[] => {
  const mapUuidToLocation = (locationUuid: string) =>
    locations?.find((location) => location.uuid === locationUuid);

  const mapUuidToLocationGroup = (locationGroupUuid: string) =>
    locationGroups?.find((locationGroup) => locationGroup.uuid === locationGroupUuid);

  return surveyItems.map<SurveyAttribute>((item) => {
    const survey = surveys?.find((survey) => survey.uuid === item.surveyUuid);

    const locationsForThisSurvey = item.locationsUuids
      ?.map(mapUuidToLocation)
      .filter(isNotUndefined);

    const locationGroupsForThisSurvey = item.locationGroupUuids
      ?.map(mapUuidToLocationGroup)
      .filter(isNotUndefined);

    return {
      ...item,
      survey,
      locations: locationsForThisSurvey || [],
      locationGroups: locationGroupsForThisSurvey || [],
    };
  });
};
